import { InputAdornment } from "@material-ui/core";
import { PrimaryButton } from "components/Buttons/PrimaryButton";
import { Input } from "components/Inputs/Input";
import Row from "components/Row";
import LoginLayout from "layouts/LoginLayout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { sendVerificationCode } from "../firebase";
import { AuthCardTitle } from "../styled";
import queryString from "query-string";
import { authObj } from "api";

export default function PhoneNumberVerification({ history, location }) {
  const [form, setForm] = useState({
    code: "",
    phone: "",
    sent: false
  });

  // This is to complete the user flow
  let redirectUrl = queryString.parse(location.search).redirect;
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaSolved, setCaptchaSolved] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [confirmation, setConfirmation] = useState(null);

  var user = useSelector(state => state.authState.firestoreUser);
  useEffect(() => {
    window.recaptchaVerifier = new authObj.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "normal",
        callback: function() {
          setCaptchaSolved(true);
        },
        "expired-callback": function() {
          setCaptchaSolved(false);
        }
      }
    );
    window.recaptchaVerifier.render();
  }, []);

  useEffect(() => {
    setForm({
      phone: user.phone || ""
    });
  }, [user]);

  const handleInput = event => {
    setError("");
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };

  function getErrorMessage(code) {
    switch (code) {
      case "auth/provider-already-linked":
        return "You already have a phone number associated with your account.";
      case "auth/phone-number-already-exists":
        return "This phone number is already associated with another account.";
      case "auth/invalid-phone-number":
        return "Invalid phone number";
      default:
        return "Something went wrong, try again later";
    }
  }

  async function sendCode() {
    setLoading(true);
    try {
      var confirmation = await sendVerificationCode(
        "+977" + form.phone,
        window.recaptchaVerifier
      );
      setConfirmation(confirmation);
      setCodeSent(true);
    } catch (e) {
      console.log(e);
      var errorMessage = getErrorMessage(e.code);
      setError(errorMessage);
    }
    setLoading(false);
  }

  async function verifyCode() {
    setLoading(true);
    await confirmation.confirm(form.code);
    setLoading(false);
    if (redirectUrl) history.push(redirectUrl);
    else history.push("/home");
  }

  return (
    <LoginLayout verifyLogin={false}>
      <AuthCardTitle style={{ marginBottom: 10 }}>
        Verify your phone number
      </AuthCardTitle>
      {codeSent ? (
        <div>
          A code has been sent to your phone, please enter it to continue.
        </div>
      ) : (
        <div>Please verify your phone number in order to get all features.</div>
      )}
      <form>
        {!codeSent ? (
          <>
            <Input
              label="Phone Number"
              name="phone"
              id="phone"
              key="phone"
              error={error}
              type="number"
              value={form.phone}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+977</InputAdornment>
                )
              }}
              onChange={handleInput}
              style={{
                marginTop: 10
              }}
            />
            {error ? (
              <span style={{ color: "red", fontSize: 10 }}>{error}</span>
            ) : null}
            <div style={{ marginBottom: 10 }} />
            <div id="recaptcha-container" />
            {captchaSolved ? (
              <Row justify="space-between" style={{ marginTop: 10 }}>
                <PrimaryButton
                  onClick={sendCode}
                  loading={loading}
                  disabled={!captchaSolved}
                >
                  Send Code
                </PrimaryButton>
              </Row>
            ) : null}
          </>
        ) : (
          <>
            <Input
              label="Verification Code"
              name="code"
              id="code"
              key="code"
              type="number"
              value={form.code}
              onChange={handleInput}
              margin="normal"
            />
            <Row justify="space-between" style={{ marginTop: 10 }}>
              <PrimaryButton
                id="sign-in-button"
                onClick={verifyCode}
                loading={loading}
              >
                Verify Code
              </PrimaryButton>
            </Row>
          </>
        )}
      </form>
    </LoginLayout>
  );
}
